import Emitter from 'tiny-emitter';

export default {
    install: (app) => {
        const emitter = new Emitter();
        app.config.globalProperties.$emitter = emitter;
    },
};